"use client";
import { Amplify } from "aws-amplify";
import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito";
import { CookieStorage } from "aws-amplify/utils";
import { amplifyConfig } from "./config";

export function configureAmplifyClient() {
  try {
    Amplify.configure(amplifyConfig, { ssr: true });

    if (typeof window !== "undefined") {
      // Browser-side token writes (e.g. forceRefresh) must emit SameSite=None
      // for the Procore iframe embed. Server-issued cookies are set
      // independently in lib/auth/writeAmplifyCookies.ts and proxy.ts.
      const secure = window.location.protocol === "https:";
      cognitoUserPoolsTokenProvider.setKeyValueStorage(
        new CookieStorage({
          path: "/",
          expires: 30,
          secure,
          sameSite: secure ? "none" : "lax",
        }),
      );
      const authConfig = Amplify.getConfig().Auth;
      if (authConfig) cognitoUserPoolsTokenProvider.setAuthConfig(authConfig);
    }
  } catch (e) {
    console.error(e);
  }
}
